import { formatURIComponent } from './utils'

export default (instance:string) => {

    const makeUrl = (path:string) => {
        return `/browser2?file_path=${formatURIComponent(path, instance)}&menu_key=group&instance=${instance}`
    }

    return [{
        instance: instance,
        pageLayout: 'tabs_small',
        sectionCategory: "group",
        slogan: '建设数据',
        pageTitle: '建设数据',
        pageTitleIcon: '',
        background_img: '/backgrounds/sunny.jpg',
        icons: [
            {
                name: '新开酒店',
                img: '/icons/趋势分析.svg',
                background: 'black',
                url: makeUrl('/内容文件/建设数据/新酒店'),
                path: "建设数据/新酒店",
            },
            {
                name: '获奖酒店',
                img: '/icons/趋势分析.svg',
                background: 'black',
                url: makeUrl('/内容文件/建设数据/获奖酒店'),
                path: "建设数据/获奖酒店",
            },
            {
                name: '建设数据',
                img: '/icons/趋势分析.svg',
                background: 'black',
                url: makeUrl('/内容文件/建设数据/建设数据'),
                path: "建设数据/建设数据"
            },
            {
                name: '预警问题',
                img: '/icons/趋势分析.svg',
                background: 'black',
                url: makeUrl('/内容文件/建设数据/预警问题'),
                path: "建设数据/预警问题"
            },
            {
                name: '优选资源',
                img: '/icons/趋势分析.svg',
                background: 'black',
                url: makeUrl('/内容文件/建设数据/优选资源'),
                path: "建设数据/优选资源"
            },
            {
                name: '培训课',
                img: '/icons/趋势分析.svg',
                background: 'black',
                url: makeUrl('/内容文件/建设数据/培训课'),
                path: "建设数据/培训课"
            },
            {
                name: '考察团',
                img: '/icons/趋势分析.svg',
                background: 'black',
                url: makeUrl('/内容文件/建设数据/考察团'),
                path: "建设数据/考察团"
            },
        ]
    }]
}